/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmPromptsCreateVersion } from "../../funcs/llmPromptsCreateVersion.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreatePromptVersionRequest$inboundSchema,
};

export const tool$llmPromptsCreateVersion: ToolDefinition<typeof args> = {
  name: "llm-prompts-create-version",
  description: `Create a new version

Creates a new version of a prompt. The new version automatically becomes the active version. Fields not provided are carried forward from the previous version.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmPromptsCreateVersion(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
